var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"\n        border\n        dark:border-gray-700\n        rounded\n        px-3\n        py-2\n        hover:bg-gray-100\n        dark:hover:bg-gray-800\n    ",attrs:{"to":{
        name: 'catalog',
        params: {
            category: _vm.category,
            subCategory: _vm.item.slug,
        },
    }}},[_c('h3',[_vm._v(" "+_vm._s(_vm.$i18n.locale == "ru" ? _vm.item.title : _vm.item.title_en)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }